import { FC } from 'react';
import { HeroSection } from './HeroSection';
import { FeaturesSection } from './FeaturesSection';
import { PricingPreview } from './PricingPreview';
import { TestimonialSection } from './TestimonialSection';
import { CTASection } from './CTASection';
import { CloudServiceSection } from './CloudServiceSection';

export const HomePage: FC = () => {
  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <PricingPreview />
      <CloudServiceSection />
      <TestimonialSection />
      <CTASection />
    </>
  );
};